import styled from '@emotion/styled';

const CertificateCriteriaStyle = styled.div`
  font-family: Lanna;
`;

export default CertificateCriteriaStyle;
